import { delay, put, takeEvery, call, select } from 'redux-saga/effects';
import { RequestWkblScriptListAction } from 'redux/actions/type';
import { REQUEST_WKBL_SCRIPT_LIST } from 'redux/actions/types';
import {
  requestWkblScriptListSuccess,
  requestWkblScriptListFailure,
  throwError,
} from 'redux/actions/actions';
import { getAPI } from 'commons/framework/KeyFlowAPIRequest';
import KeyFlowResponse from 'commons/framework/KeyFlowResponse';
import KeyFlowError from 'commons/framework/KeyFlowError';
import { SPECIAL_CHARACTER_ERROR } from 'commons/constants/KeyFlowMessage';
import { API } from 'commons/constants/KeyFlowAPI';
import WkblScriptVO from 'commons/vo/WkblScriptVO';
import { PaginationType } from 'commons/framework/type';
import { isContainSpecialCharacter } from 'commons/utils/commonUtil';
import { AxiosResponse } from 'axios';

function* requestWkblScriptListSaga(action: RequestWkblScriptListAction) {
  try {
    const { param } = action.payload;
    if (isContainSpecialCharacter(param.keywords)) {
      throw new KeyFlowError(SPECIAL_CHARACTER_ERROR);
    }
    let wkblScriptParam: any = param.getParam();

    if (wkblScriptParam.season === 'all') {
      const { season, ...rest } = wkblScriptParam;
      wkblScriptParam = rest;
    }

    const returnCount: number = wkblScriptParam.retr;

    const response: AxiosResponse = yield call(getAPI, API.WKBL_SCRIPT, wkblScriptParam);
    const keyFlowResponse = new KeyFlowResponse(response.data);
    const resultList: WkblScriptVO[] = keyFlowResponse.getResult(WkblScriptVO) as WkblScriptVO[];
    const pagination: PaginationType = keyFlowResponse.page;
    yield put(
      requestWkblScriptListSuccess({ wkblScriptList: resultList, pagination, returnCount }),
    );
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestWkblScriptListFailure());
  }
}

export function* watchWkblScriptSaga() {
  yield takeEvery(REQUEST_WKBL_SCRIPT_LIST, requestWkblScriptListSaga);
}
